import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ViewMapComponent } from "./view-map/view-map";
import { AnalyticsDashboardMapComponent } from "./view-map/analytics-dashboard-map";

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    ViewMapComponent, AnalyticsDashboardMapComponent
  ],
  exports: [
    ViewMapComponent, AnalyticsDashboardMapComponent
  ]
})
export class ViewMapModule { }
